import { useNavigate } from "react-router-dom";
import mealTray from "../../assets/images/plate-2.png";
import Icon from "../common/Icon";
import { cleanHTML2, isSnack } from "../utils/commonHelper";

const MealCard = ({ item, opacity }) => {
  const navigate = useNavigate();

  return (
    <div
      className="
        bg-[#295b24]/10 rounded-[25px]
        grid
        grid-cols-1
        md:grid-cols-[1.5fr_1fr]
        xl:grid-cols-[2fr_3.5fr_2.5fr]
        2xl:grid-cols-[2fr_5fr_3fr]
        2.5xl:grid-cols-[1.5fr_5fr_2fr]
        gap-6 xl:gap-12
      "
    >
      {/* Left section — full width on md and below */}
      <div
        className="
          rounded-[25px] px-8 md:px-10 py-10 flex flex-col items-start justify-center
          md:col-span-2 xl:col-span-1
        "
        style={{
          backgroundColor: `rgba(41, 91, 36, ${opacity})`,
          transition:
            "background-color 0.3s ease, margin 0.3s ease, transform 0.2s ease, box-shadow 0.2s ease",
        }}
      >
        <div>
          <p className="text-32pt 1xl:text-[38px] leading-none">
            {isSnack(item?.title) ? "Snacks" : item?.title}
          </p>
          <p className="text-24pt 1xl:text-[28px]">Meal</p>
        </div>
        <button className="bg-green mt-2 xl:mt-5 flex items-center gap-1 px-10 py-1 text-white rounded-[5px] font-mono whitespace-nowrap cursor-default">
          <span className="text-16pt 1xl:text-[20px]">
            {`${item?.price?.$numberDecimal} AED / Meal`}
          </span>
        </button>
      </div>

      {/* Middle section — description */}
      <div
        className=" 
          flex flex-col justify-center gap-4 w-full py-0 px-8 md:px-10 md:pb-10 xl:px-0
          xl:py-6
        "
      >
        {item.description && (
          <div
            className="terms-container"
            dangerouslySetInnerHTML={{ __html: cleanHTML2(item.description) }}
          />
        )}
      </div>

      {/* Right section — image */}
      {item.image && (
        <div
          className="
      relative flex items-center justify-center 
      md:justify-end md:pe-10 xl:pe-0 xl:justify-start pb-3
      md:py-8 xl:py-10
    "
        >
          {/* Tray image */}
          <div className="relative flex items-center  justify-center w-[250px] xl:w-[280px]">
            <img
              src={mealTray}
              alt="tray"
              className="w-full h-auto object-contain -translate-x-4 md:translate-x-0"
            />

            {/* Meal image inside tray — centered perfectly */}
            <div
              className="
          absolute left-1/2 top-1/2  -translate-y-1/2 -translate-x-1/2 inset-0 flex items-center justify-center
         
          pointer-events-none
 lg:w-[210px] lg:h-[210px]    w-[190px] h-[190px]      "
            >
              <img
                src={process.env.REACT_APP_BACKEND_URL + "public/" + item.image}
                onError={(e) => {
                  e.currentTarget.src = require("../../assets/images/link.png");
                }}
                alt={item.title}
                className="-translate-x-2 md:translate-x-2
           w-full h-full
            h-auto object-contain
            drop-shadow-md
          "
              />
            </div>
          </div>

          {/* Plus icon */}
          <div
            title="Click to view meal menu"
            onClick={() => navigate(`/meals/${item.title}`)}
            className="
        absolute cursor-pointer hover:text-orange
        right-8 bottom-5
        bg-white rounded-full transition-colors
      "
          >
            <Icon icon="plus" className="w-10 h-10" />
          </div>
        </div>
      )}
    </div>
  );
};

export default MealCard;
